module.exports = __webpack_public_path__ + "img/toilet-paper.38f66438.svg";